import {
  BellOutlined,
  FundOutlined,
  TeamOutlined,
  WalletOutlined,
  CalendarOutlined,
  FileTextOutlined,
  RobotOutlined,
  MessageOutlined,
  SettingOutlined,
  ContactsOutlined,
  CreditCardOutlined,
  DollarOutlined
} from '@ant-design/icons';

const icons = {
  TeamOutlined,
  FundOutlined,
  WalletOutlined,
  CalendarOutlined,
  BellOutlined,
  MessageOutlined,
  FileTextOutlined,
  RobotOutlined,
  SettingOutlined,
  ContactsOutlined,
  CreditCardOutlined,
  DollarOutlined
};

const users = {
  id: 'group-users',
  title: 'Operations',
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'members',
      title: 'Members',
      type: 'item',
      url: '/members',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'groups',
      title: 'Groups',
      type: 'item',
      url: '/groups',
      icon: icons.FundOutlined,
      breadcrumbs: false
    },
    {
      id: 'contributions',
      title: 'Contributions',
      type: 'item',
      url: '/contributions',
      icon: icons.WalletOutlined,
      breadcrumbs: false
    },
    {
      id: 'loans',
      title: 'Loans',
      type: 'item',
      url: '/loans',
      icon: icons.WalletOutlined,
      breadcrumbs: false
    },
    {
      id: 'meetings',
      title: 'Meetings',
      type: 'item',
      url: '/meetings',
      icon: icons.CalendarOutlined,
      breadcrumbs: false
    },
    {
      id: 'notifications',
      title: 'Notifications',
      type: 'item',
      url: '/notifications',
      icon: icons.BellOutlined,
      breadcrumbs: false
    },
    {
      id: 'marketing-leads',
      title: 'Marketing Leads',
      type: 'item',
      url: '/marketing/leads',
      icon: icons.ContactsOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-applications',
      title: 'Admin Approvals',
      type: 'item',
      url: '/admin-applications',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'plans',
      title: 'Plans',
      type: 'item',
      url: '/plans',
      icon: icons.DollarOutlined,
      breadcrumbs: false
    },
    {
      id: 'subscriptions',
      title: 'Subscriptions',
      type: 'item',
      url: '/subscriptions',
      icon: icons.DollarOutlined,
      breadcrumbs: false
    },
    {
      id: 'billing',
      title: 'Billing',
      type: 'item',
      url: '/billing',
      icon: icons.CreditCardOutlined,
      breadcrumbs: false
    },
    {
      id: 'sms-messages',
      title: 'SMS Tracking',
      type: 'item',
      url: '/sms-messages',
      icon: icons.MessageOutlined,
      breadcrumbs: false
    },
    {
      id: 'wallet-transactions',
      title: 'Wallet Transactions',
      type: 'item',
      url: '/wallet-transactions',
      icon: icons.WalletOutlined,
      breadcrumbs: false
    },
    {
      id: 'wallet-purchases',
      title: 'Buy Airtime & Data',
      type: 'item',
      url: '/wallet-purchases',
      icon: icons.WalletOutlined,
      breadcrumbs: false
    },
    {
      id: 'transaction-callbacks',
      title: 'Callback Tracker',
      type: 'item',
      url: '/transaction-callbacks',
      icon: icons.WalletOutlined,
      breadcrumbs: false
    },
    {
      id: 'mobile-inactivity-settings',
      title: 'Mobile Settings',
      type: 'item',
      url: '/settings/mobile-inactivity',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: icons.FileTextOutlined,
      breadcrumbs: false
    },
    {
      id: 'ai-chatbot',
      title: 'AI Chatbot',
      type: 'item',
      url: '/ai/chatbot',
      icon: icons.RobotOutlined,
      breadcrumbs: false
    }
  ]
};

export default users;
